<script>
import Error404 from '@/components/errors/404.vue'

export default {
    components: { Error404 },
    page: {
        title: '404',
        meta: [{ name: 'description', content: '404' }],
    },
}
</script>

<template>
    <Layout>
        <error-404 />
    </Layout>
</template>
